// src/store/modules/theme.js

const state = {
  // O tema padrão é 'light'. Tenta carregar o tema salvo do localStorage.
  theme: localStorage.getItem('theme') || 'light'
};

const mutations = {
  SET_THEME(state, theme) {
    state.theme = theme;
    // Define o tema no corpo do documento para que o Vuetify possa aplicar os estilos
    document.documentElement.setAttribute('data-theme', theme);
    // Salva a preferência do tema no localStorage
    localStorage.setItem('theme', theme);
  }
};

const actions = {
  // Action para alternar entre os temas 'light' e 'dark'
  toggleTheme({ commit, state }) {
    const newTheme = state.theme === 'light' ? 'dark' : 'light';
    commit('SET_THEME', newTheme);
  },
  // Action para inicializar o tema quando o aplicativo é carregado
  initTheme({ commit, state }) {
    commit('SET_THEME', state.theme);
  }
};

const getters = {
  // Getter para obter o tema atual
  currentTheme: state => state.theme,
  // Getter para verificar se o tema atual é escuro
  isDark: state => state.theme === 'dark'
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
